import './signers-tab.scss';
import { Table, Loader, IconBtn } from '@ru-digital-assets/ui-component';
import { useState, useCallback, useEffect } from 'react';
import { RowComponent, getColumns } from './components';
import { useDispatch, useSelector } from 'hooks/redux';
import OperatorAPI from 'services/api/Operator';
import { setPush } from 'store/actions/app';
import { ISignerInfo } from 'constants/signers';
import { PlusIcon } from 'assets/icons';
import { useHistory } from 'react-router';

export default function SignersTab() {
  const history = useHistory();
  const dispatch = useDispatch();
  const token = useSelector((s) => s.auth.account.token);
  const [signers, setSigners] = useState<ISignerInfo[]>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    OperatorAPI.getSigners(token)
      .then((response) => {
        setSigners(response.data);
      })
      .catch(() => {
        dispatch(
          setPush({
            type: 'error',
            message: 'Не удалось загрузить информацию об исполнителях',
          })
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const onAddSigner = useCallback(() => {
    history.push('/operator/add-signer-permissions');
  }, []);

  return (
    <div className="signers-tab">
      <div className="flex justify-between align-center">
        <p className="p p_bold">Добавление и настройка исполнителей</p>
        <IconBtn
          title="Добавить полномочие исполнителю"
          outlined
          sm
          onClick={onAddSigner}
          icon={<PlusIcon color="#2555FE" />}
        />
      </div>
      {loading || !signers ? (
        <div className="flex justify-center mt_32">
          <Loader />
        </div>
      ) : (
        <div className="mt_24">
          <Table
            loading={false}
            data={signers}
            columns={getColumns()}
            RowComponent={RowComponent}
            showHeaderBottomLine
          />
        </div>
      )}
    </div>
  );
}
